import React, { FC } from 'react';

import { Box, Card, CardContent, Divider, Typography } from '@mui/material';

import WaterDropIcon from '@mui/icons-material/WaterDrop';

import AuthorityProvidedFieldsDataEntry from './AuthorityProvidedFieldsDataEntry';
import WaterAuthoritySelectionDropdown from './WaterAuthoritySelectionDropdown';

import { BackflowJobGroup } from '../../model';

interface WaterAuthorityUpdatingFieldsProps {
  backflowJobGroup: BackflowJobGroup;
  fetchBackflowJobGroup: () => void;
}

const WaterAuthorityUpdatingFields: FC<WaterAuthorityUpdatingFieldsProps> = (props) => {
  const { backflowJobGroup, fetchBackflowJobGroup } = props;

  return (
    <Card elevation={3}>
      <CardContent>
        <Box display="flex" alignItems="center" mb={2}>
          <WaterDropIcon color="primary" sx={{ mr: 1 }} />
          <Typography variant="h6" fontWeight="600">
            Water Authority
          </Typography>
        </Box>
        <Divider sx={{ mb: 1 }} />
        <Box>
          <Typography variant="body2" color="text.secondary" fontStyle="italic">
            Changing Water Authority information updates values for this app AND for Servman.
          </Typography>
        </Box>
        <Box display="flex" flexDirection="column" gap={2} mb={3}>
          <WaterAuthoritySelectionDropdown
            backflowJobGroup={backflowJobGroup}
            fetchBackflowJobGroup={fetchBackflowJobGroup}
          />
        </Box>
        <Box display="flex" flexDirection="column" gap={2} mb={3}>
          <Typography variant="h6" fontWeight="600">
            Preferred Submission Method
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {backflowJobGroup.submission_method || 'Not set'}
          </Typography>
        </Box>
        <AuthorityProvidedFieldsDataEntry
          backflowJobGroup={backflowJobGroup}
          fetchBackflowJobGroup={fetchBackflowJobGroup}
        />
      </CardContent>
    </Card>
  );
};

export default WaterAuthorityUpdatingFields;
